import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de470bb10599dc/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de470bb10599dc/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de470bb10599dc/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de470bb10599dc/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de470bb10599dc/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/app/[locale]/branches/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/node_modules/next/dist/client/link.js");
